import {
  deleteApiV1ThreeLetterCodePartnerAdminsClientsClientId,
  getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdParams } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';
import type { Key } from 'swr';

/**
 * パートナー管理者向け利用企業削除フック（PEN-699 T08）
 *
 * - DELETE /api/v1/{three_letter_code}/partner_admins/clients/{client_id}
 * - クエリパラメータ（reason / reason_detail）は trigger 時に渡す
 *
 * trigger 経由パターンを採用する理由:
 * params（reason / reason_detail）は送信時にフォームの値から確定するため、
 * hook 初期化時には決まっておらず trigger 経由で渡す必要がある。
 */
export const useDeletePartnerAdminsClient = (
  threeLetterCode: string,
  clientId: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) =>
  useMutation(
    getDeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdMutationKey(threeLetterCode, clientId),
    (_: Key, { arg }: { arg: DeleteApiV1ThreeLetterCodePartnerAdminsClientsClientIdParams }) =>
      deleteApiV1ThreeLetterCodePartnerAdminsClientsClientId(threeLetterCode, clientId, arg),
    options
  );
